// export function formatDate(date) : string {
export function enableChangeResult(employeePosition, 
                                  employeePositionEnableChanges, 
                                  result, 
                                  controlName,
                                  form) : any {
  var enable = false;
  if (result == null || result == "")
    enable = true; //this.form.get(controlName).enable();
  else {
    var array = employeePositionEnableChanges.split(",");
    // array.push(...this.employeePositionToAdmin.split(','));
    const elementosEncontrados = array.filter(
      (item) => item == employeePosition
    );
    if (elementosEncontrados.length > 0)
      enable = true;//this.form.get(controlName).enable();
  }
  if(enable)
    form.get(controlName).enable();
  else
    form.get(controlName).disable();
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/functions/enableChangeResult.function.ts